import React from "react";

const VideoBarPersonMicOff = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.8086 18.5449V22.626" stroke="white" strokeWidth="1.37923" />
      <path
        d="M9.75391 13.9521C9.75391 20.0739 19.8605 20.0739 19.8605 13.9521"
        stroke="white"
        strokeWidth="1.37923"
      />
      <path
        d="M17.895 9.38795C17.895 7.68241 16.5124 6.2998 14.8069 6.2998C13.1014 6.2998 11.7188 7.68241 11.7188 9.38795V13.4145C11.7188 15.1201 13.1014 16.5027 14.8069 16.5027C16.5124 16.5027 17.895 15.1201 17.895 13.4145V9.38795Z"
        fill="white"
      />
      <path
        d="M23.6682 21.2635L7.34766 6.36328L5.99993 7.83948L22.3204 22.7397L23.6682 21.2635Z"
        fill="white"
      />
    </svg>
  );
};

export default VideoBarPersonMicOff;
